// src/Lexcode/index.jsx
import React, { useState } from "react";
import GestureControl from "./components/GestureControl";
import "./styles/Lexcode.css";

export default function Lexcode() {
  const [pos, setPos] = useState({ x: 100, y: 100 });
  return (
    <div
      className="lexcode-container"
      style={{ position: "relative", width: "100vw", height: "100vh" }}
    >
      {/* 拖拽方块 */}
      <div
        style={{
          position:   "absolute",
          left:       pos.x,
          top:        pos.y,
          width:      50,
          height:     50,
          background: "tomato",
          borderRadius: 4
        }}
      />
      <GestureControl onDrag={setPos} />
    </div>
  );
}
